import React, { useState } from 'react';
import { Collapse, List, useTheme } from '@mui/material';
import { OnboardingItem } from 'services/onboarding/utils';
import OnboardingItemRow from './OnboardingItemRow';
import OnboardingStepHeader from './OnboardingStepHeader';

export interface Props {
	stepName: string;
	items?: OnboardingItem[];
	isStepOpen: boolean;
	isLastStep: boolean;
}
const OnboardingStep = (props: Props) => {
	const { items, stepName, isStepOpen, isLastStep } = props;
	const [showStep, setShowStep] = useState(isStepOpen);
	const theme = useTheme();
	const completedItems = items?.filter((item) => item.done).length ?? 0;
	const itemsInTotal = items?.length ?? 1;
	return (
		<>
			<List
				disablePadding
				sx={{
					backgroundColor: theme.palette.background.paper,
					boxShadow: showStep ? '0px 2px 6px 0px #A3A3A380' : '0px 1px 3px 0px #A3A3A380',
					marginBottom: isLastStep ? 3 : 2,
					borderRadius: '6px',
				}}
			>
				<OnboardingStepHeader
					title={stepName}
					completedItems={completedItems}
					itemsInTotal={itemsInTotal}
					onClick={() => setShowStep(!showStep)}
				/>
				<Collapse in={showStep}>
					{items?.map((item, index) => (
						<OnboardingItemRow item={item} itemNumber={index + 1} key={item.title + index} />
					))}
				</Collapse>
			</List>
		</>
	);
};

export default OnboardingStep;
